import { gql } from '@apollo/client';

export const GET_PUSH_CAMPAIGN_ELIGIBLE_USERS = gql`
    query GetPushCampaignEligibleUsers($data: EmailTargetingOptionsInput) {
        getPushCampaignEligibleUsers(data: $data) {
            id
            email
            fullName
            planType
            createdAt
            lastActive
            engagementScore
            pushDeviceCount
        }
    }
`;
